// Notification Types
export const NOTIFICATION_TYPE_INFO = 1;
export const NOTIFICATION_TYPE_SUCCESS = 2;
export const NOTIFICATION_TYPE_WARNING = 3;
export const NOTIFICATION_TYPE_ERROR = 4;

export const ActivityStatus = Object.freeze({
  Created: 1,
  Done: 2,
});

export const FcmNotificationType = Object.freeze({
  Normal: 1,
  Reload: 2,
});

export const DeviceType = Object.freeze({
  Kds: "kds",
  Cds: "cds",
  Pos: "pos",
});

// Authentication
export const AUTH_ERROR_STORAGE_KEY = "auth_error";

export const TransactionType = Object.freeze({
  Cash: 1,
  Mada: 2,
  Stc: 3,
  Credit: 4,
  Multipayment: 5,
});

export const transactionTypes = [
  { id: TransactionType.Cash, text: "Cash", translationKey: "cash" },
  { id: TransactionType.Credit, text: "Card", translationKey: "card" },
  {
    id: TransactionType.Multipayment,
    text: "Multi Payment",
    translationKey: "multi_payment",
  },
];

export const BalanceDeductionType = Object.freeze({
  Subscription: 1,
  QrOrdering: 2,
  TableManagement: 3,
  OrderManagement: 4,
  WaiterManagement: 5,
  JobManagement: 6,
  Stock: 7,
  TapToPay: 8,
  CustomerManagement: 9,
  A4SalesInvoice: 10,
  Ticketing: 11,
  KitchenDisplaySystem: 12,
  CustomerDisplaySystem: 13,
  Website: 14,
  ZatcaEInvoicing: 15,
});

export const deduction_types = [
  {
    id: BalanceDeductionType.Subscription,
    text: "Subscription",
    translationKey: "subscription",
  },
  {
    id: BalanceDeductionType.QrOrdering,
    text: "QR Ordering",
    translationKey: "qr_order",
  },
  {
    id: BalanceDeductionType.TableManagement,
    text: "Table Management",
    translationKey: "table_management",
  },
  {
    id: BalanceDeductionType.OrderManagement,
    text: "Order Management",
    translationKey: "order_management",
  },
  {
    id: BalanceDeductionType.WaiterManagement,
    text: "Waiter Management",
    translationKey: "waiter_management",
  },
  {
    id: BalanceDeductionType.JobManagement,
    text: "Job Management",
    translationKey: "job_management",
  },
  {
    id: BalanceDeductionType.Stock,
    text: "Stock",
    translationKey: "stock",
  },
  {
    id: BalanceDeductionType.TapToPay,
    text: "TapToPay",
    translationKey: "tap_to_pay",
  },
  {
    id: BalanceDeductionType.CustomerManagement,
    text: "Customer Management",
    translationKey: "customer_management",
  },
  {
    id: BalanceDeductionType.A4SalesInvoice,
    text: "A4 Sales Invoice",
    translationKey: "sales_invoice",
  },
  {
    id: BalanceDeductionType.Ticketing,
    text: "Ticketing",
    translationKey: "pricing_group_ticket_title",
  },
  {
    id: BalanceDeductionType.KitchenDisplaySystem,
    text: "Kitchen Display System",
    translationKey: "kitchen_display_screen",
  },
  {
    id: BalanceDeductionType.CustomerDisplaySystem,
    text: "Customer Display System",
    translationKey: "customer_display_screen",
  },
  {
    id: BalanceDeductionType.Website,
    text: "Website",
    translationKey: "website",
  },
  {
    id: BalanceDeductionType.ZatcaEInvoicing,
    text: "ZATCA E-Invoicing",
    translationKey: "zatca_e_invoicing",
  },
];

export const AddonBillingCycle = Object.freeze({
  Monthly: 1,
  Yearly: 2,
  Daily: 3,
});

export const SubscriptionPlan = Object.freeze({
  Monthly: 1,
  Quarterly: 2,
  Yearly: 3,
});

export const PlanType = Object.freeze({
  Basic: 1,
  Pro: 2,
  Daily: 3,
});

export const PlanPeriod = Object.freeze({
  Monthly: 1,
  Yearly: 2,
  Daily: 3,
});

export const RefundType = Object.freeze({
  Full: 1,
  Partial: 2,
});

// ZATCA refund / credit-note reasons
export const ZATCA_REFUND_REASON_CANCELLATION_SUSPENSION =
  "Cancellation/Suspension";
export const ZATCA_REFUND_REASON_GOODS_SERVICES_REFUND =
  "Goods/Services Refund";
export const ZATCA_REFUND_REASON_PRICE_REDUCTION_DISCOUNT =
  "Price Reduction/Discount";
export const ZATCA_REFUND_REASON_INVOICE_ERRORS = "Invoice Errors";
export const ZATCA_REFUND_REASON_CHANGE_IN_INFORMATION =
  "Change in Information";

export const zatcaRefundReasons = [
  {
    id: ZATCA_REFUND_REASON_CANCELLATION_SUSPENSION,
    text: "zatca_refund_reason_cancellation_suspension",
  },
  {
    id: ZATCA_REFUND_REASON_GOODS_SERVICES_REFUND,
    text: "zatca_refund_reason_goods_services_refund",
  },
  {
    id: ZATCA_REFUND_REASON_PRICE_REDUCTION_DISCOUNT,
    text: "zatca_refund_reason_price_reduction_discount",
  },
  {
    id: ZATCA_REFUND_REASON_INVOICE_ERRORS,
    text: "zatca_refund_reason_invoice_errors",
  },
  {
    id: ZATCA_REFUND_REASON_CHANGE_IN_INFORMATION,
    text: "zatca_refund_reason_change_in_information",
  },
];

export const UserType = Object.freeze({
  Admin: 1,
  BusinessOwner: 2,
  Employee: 3,
  AdminStaff: 4,
  SuperAdmin: 5,
  Referral: 6,
  Reseller: 7,
});

export const CompanyStatus = Object.freeze({
  Active: 1,
  Kyc: 2,
  Review: 3,
  SubscriptionEnded: 4,
  SubscriptionInReview: 5,
  SubscriptionInvoiceGenerated: 6,
  Blocked: 99,
});

export const HelpdeskTicketStatus = Object.freeze({
  Created: 1,
  InProgress: 2,
  Done: 3,
  Closed: 4,
});

export const InvoiceStatus = Object.freeze({
  Cancelled: 1,
  Paid: 2,
  Refunded: 3,
  Unpaid: 6,
  RechargeRequest: 7,
});

export const PaymentStatus = Object.freeze({
  Unpaid: 0,
  Paid: 1,
  Declined: 2,
});

export const PaymentBrand = Object.freeze({
  Visa: 1,
  Master: 2,
  Mada: 3,
  Stcpay: 4,
});

export const InvoiceDetailType = Object.freeze({
  Subscription: 1,
  License: 2,
  Discount: 3,
  Tax: 4,
  Addon: 6,
  BalanceTopup: 7,
});

export const InvoiceType = Object.freeze({
  Subscription: 1,
  License: 2,
  Addon: 4,
  BalanceTopup: 5,
});

// Sidebar Menu Keys
export const SIDEBAR_WIDTH = 220;
export const SIDEBAR_COLLAPSED_WIDTH = 80;
export const SIDEBAR_MENU_KEY_HOME = "home";
export const SIDEBAR_MENU_KEY_INVOICES = "invoices";
export const SIDEBAR_MENU_KEY_STORE_CONFIGURATION = "store-configuration";
export const SIDEBAR_MENU_KEY_STOCK = "stock";
export const SIDEBAR_MENU_KEY_LOW_STOCK = "low-stock";

// Integration Types
export const ODOO = "Odoo";
export const XERO = "Xero";
export const ZOHO = "Zoho";

export const TransactionStatus = Object.freeze({
  Pending: 1,
  InProgress: 2,
  Completed: 3,
  Cancelled: 4,
});

export const OrderType = Object.freeze({
  DineIn: "dinein",
  TakeAway: "takeaway",
});

export const TransactionOrderSource = Object.freeze({
  Pos: 1,
  Waiter: 2,
  QrOrder: 3,
  Kiosk: 4,
});

export const transactionOrderSource = [
  { id: TransactionOrderSource.Pos, text: "POS", translationKey: "pos" },
  {
    id: TransactionOrderSource.Waiter,
    text: "Waiter",
    translationKey: "waiter",
  },
  {
    id: TransactionOrderSource.QrOrder,
    text: "QR Order",
    translationKey: "qr_order",
  },
  {
    id: TransactionOrderSource.Kiosk,
    text: "Kiosk",
    translationKey: "kiosk",
  },
];

export const TransactionPaymentChannel = Object.freeze({
  TapToPay: "taptopay",
});

export const AddonName = Object.freeze({
  QrOrdering: "QR Ordering",
  TableManagement: "Table Management",
  OrderManagement: "Order Management",
  WaiterManagement: "Waiter Management",
  JobManagement: "Job Management",
  Stock: "Stock",
  TapToPay: "TapToPay",
  CustomerManagement: "Customer Management",
  A4SalesInvoice: "A4 Sales Invoice",
  Ticketing: "Ticketing",
  KitchenDisplaySystem: "Kitchen Display System",
  CustomerDisplaySystem: "Customer Display System",
  ZatcaEInvoicing: "ZATCA E-Invoicing",
  Website: "Website",
});

export const InventoryRequestStatus = Object.freeze({
  Pending: 0,
  Completed: 1,
  Cancelled: 2,
  Rejected: 3,
});

export const SaleInvoiceStatus = Object.freeze({
  Draft: 1,
  IssueInvoice: 2,
  PartialPaidInvoice: 3,
  PaidInvoice: 4,
  Cancelled: 5,
});

export const TicketScanStatus = Object.freeze({
  NotScanned: 0,
  PartiallyScanned: 1,
  FullyScanned: 2,
  Expired: 3,
  Refunded: 4,
});

export const ticketStatus = [
  { id: TicketScanStatus.NotScanned, text: "not_scanned" },
  { id: TicketScanStatus.PartiallyScanned, text: "partially_scanned" },
  { id: TicketScanStatus.FullyScanned, text: "fully_scanned" },
  { id: TicketScanStatus.Expired, text: "expired" },
  { id: TicketScanStatus.Refunded, text: "refunded" },
];

export const ProductImageGenerationItemStatus = Object.freeze({
  Pending: "pending",
  Processing: "processing",
  Completed: "completed",
  Failed: "failed",
  Skipped: "skipped",
});

export const ProductImageGenerationJobStatus = Object.freeze({
  Queued: "queued",
  Processing: "processing",
  Completed: "completed",
  Failed: "failed",
});

export const ResellerStatus = Object.freeze({
  Active: 1,
  Kyc: 2,
  Rejected: 3,
  InReview: 4,
  Blocked: 99,
});

// Trial Duration
export const TRIAL_DURATION = 8; // in days

export const KitchenDisplayStatus = Object.freeze({
  Awaiting: 1,
  Preparing: 2,
  Cooked: 3,
});

export const ZatcaBranchOnboardingStatus = Object.freeze({
  NotStarted: "not_started",
  InProgress: "in_progress",
  Onboarded: "onboarded",
  NeedsReonboarding: "needs_reonboarding",
  Failed: "failed",
});

export const ZatcaDeviceStatus = Object.freeze({
  PendingOnboarding: "pending_onboarding",
  CompliancePending: "compliance_pending",
  CompliancePassed: "compliance_passed",
  Active: "active",
  Inactive: "inactive",
  CsidExpired: "csid_expired",
  NeedsReonboarding: "needs_reonboarding",
});

export const ZatcaEnvironment = Object.freeze({
  Sandbox: "sandbox",
  Simulation: "simulation",
  Production: "production",
});

export const ZatcaInvoiceStatus = Object.freeze({
  Pending: "pending",
  Submitted: "submitted",
  Accepted: "accepted",
  AcceptedWithWarnings: "accepted_with_warnings",
  Rejected: "rejected",
  Failed: "failed",
});

// PDF: 'failed' is gated for manual retry only when retry_count >= MAX.
export const ZATCA_INVOICE_RETRY_MAX = 5;

export const ZatcaDocumentType = Object.freeze({
  Invoice: "invoice",
  CreditNote: "credit_note",
  DebitNote: "debit_note",
});

export const ZatcaInvoiceSubtype = Object.freeze({
  Standard: "standard",
  Simplified: "simplified",
});

// CSID expiry color thresholds (days), per PDF spec.
export const ZATCA_CSID_DAYS_GREEN = 60;
export const ZATCA_CSID_DAYS_AMBER_MIN = 15;
export const ZATCA_CSID_DAYS_RED = 15;

export const zatcaInvoiceStatuses = [
  {
    id: ZatcaInvoiceStatus.Pending,
    text: "pending",
    color: "var(--color-info)",
  },
  {
    id: ZatcaInvoiceStatus.Submitted,
    text: "submitted",
    color: "var(--color-info)",
  },
  {
    id: ZatcaInvoiceStatus.Accepted,
    text: "accepted",
    color: "var(--color-success)",
  },
  {
    id: ZatcaInvoiceStatus.AcceptedWithWarnings,
    text: "accepted_with_warnings",
    color: "var(--color-success)",
  },
  {
    id: ZatcaInvoiceStatus.Failed,
    text: "failed",
    color: "orange",
  },
  {
    id: ZatcaInvoiceStatus.Rejected,
    text: "rejected",
    color: "var(--color-danger)",
  },
];

export const zatcaDocumentTypes = [
  {
    id: ZatcaDocumentType.Invoice,
    text: "invoice",
    color: "default",
  },
  {
    id: ZatcaDocumentType.CreditNote,
    text: "credit_note",
    color: "geekblue",
  },
  {
    id: ZatcaDocumentType.DebitNote,
    text: "debit_note",
    color: "magenta",
  },
];

export const zatcaInvoiceSubtypes = [
  {
    id: ZatcaInvoiceSubtype.Standard,
    text: "zatca_subtype_standard",
    color: "default",
  },
  {
    id: ZatcaInvoiceSubtype.Simplified,
    text: "zatca_subtype_simplified",
    color: "default",
  },
];

export const ZATCA_RESPONSE_STATUS_CLEARED = "CLEARED";
export const ZATCA_RESPONSE_STATUS_REPORTED = "REPORTED";
export const ZATCA_RESPONSE_STATUS_REJECTED = "REJECTED";

export const zatcaResponseStatuses = [
  {
    id: ZATCA_RESPONSE_STATUS_CLEARED,
    text: "cleared",
    color: "var(--color-success)",
  },
  {
    id: ZATCA_RESPONSE_STATUS_REPORTED,
    text: "reported",
    color: "var(--color-info)",
  },
  {
    id: ZATCA_RESPONSE_STATUS_REJECTED,
    text: "rejected",
    color: "var(--color-danger)",
  },
];
